import React from 'react'

export const SeccIframeMobile = () => {


    return (
        <div className="main-iframe-mobile" id="scroll-mobile">
            <iframe src="https://amnistia.org.mx/peticiones/hastaserescuchadas/firma.php" width="100%" height="100%" frameBorder="0" title="firma"></iframe>
        </div>
    )
}
